import React from 'react';

import {
  AudienceSegmentIsFirstPartyTrue,
  AudienceSegmentIsFirstPartyUnknown,
  AudienceSegmentLogicOr,
  AudienceSegmentTypeFirstParty,
} from '~/src/dash/api/console-api';
import { EBool } from '~/src/dash/api/types/bool';
import { IStore } from '~/src/dash/reducers/store';
import { IBaseState, IReduxActionProps, ISessionStateProps } from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';
import { AudienceManagerSegmentFormView } from '~/src/dash/views/audience-manager-segment-form-view';

interface IProps extends IBaseState, IReduxActionProps, ISessionStateProps {}

export const AudienceManagerCombineSegmentsView = decorate(
  {
    redux: (state: IStore) => {
      return {
        session: state.session,
      };
    },
  },
  function (props: IProps) {
    const { publisher } = props.session;
    const liverampConfigured =
      publisher.LiverampEnabled === EBool.EBool_TRUE &&
      (publisher.LiverampClientNames !== '' ||
        publisher.LiverampClientNamesFirstParty !== '' ||
        publisher.LiverampOTTHubNames !== '');
    const transunionEnabled = publisher.TransunionEnabled === EBool.EBool_TRUE;
    return (
      <AudienceManagerSegmentFormView
        segment={{
          ID: '',
          CreatedAt: '',
          UpdatedAt: '',
          DeletedAt: '',
          Name: 'segment-' + Date.now(),
          URL: '',
          IsFirstParty:
            liverampConfigured || transunionEnabled
              ? AudienceSegmentIsFirstPartyUnknown
              : AudienceSegmentIsFirstPartyTrue,
          ThirdPartyID: '',
          ThirdPartySegmentIDs: '',
          Logic: AudienceSegmentLogicOr,
          AudienceSegmentType:
            liverampConfigured || transunionEnabled ? '' : AudienceSegmentTypeFirstParty,
          LiverampOTTHubPrefix: '',
        }}
        combineSegments={true}
      />
    );
  },
);
